import React, { useState, useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useOrganizationFeatureUIContext } from "../OrganizationFeatureUIContext";
import { OrganizationFeatureEditForm } from "./OrganizationFeatureEditForm";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/organization-feature/organizationFeatureAction";
import * as organizationActions from "../../../_redux/organization/organizationAction";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../../_metronic/_helpers";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { updateOrganizationFeatures } from "../../../_redux/organization-feature/organizationFeatureCrud";

export const OrganizationFeatureEditDialog = ({ id, show, onHide }) => {
  // OrganizationFeature UI Context
  const organizationFeatureUIContext = useOrganizationFeatureUIContext();
  const organizationFeatureUIProps = useMemo(() => {
    return {
      initOrganizationFeature:
        organizationFeatureUIContext.initOrganizationFeature,
      queryParams: organizationFeatureUIContext.queryParams,
      setQueryParams: organizationFeatureUIContext.setQueryParams
    };
  }, [organizationFeatureUIContext]);

  const dispatch = useDispatch();
  const { actionsLoading, error } = useSelector(
    state => state.organizationFeatures,
    shallowEqual
  );
  const {
    organizationForEdit,
    actionsLoading: organizationLoading
  } = useSelector(state => state.superAdminOrganization, shallowEqual);
  const [features, setFeatures] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);

  if (error) {
    toast.error(error, toastOption);
  }

  useEffect(() => {
    if (id) {
      dispatch(organizationActions.fetchOrganization(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (organizationForEdit && organizationForEdit.organization_features) {
      const { organization_features } = organizationForEdit;

      setFeatures(organization_features);
    }
  }, [organizationForEdit]);

  async function saveFeatures(features) {
    try {
      setFetchLoading(true);

      const res = await updateOrganizationFeatures({ features });

      toast.success(`Organization Features updated successfully`, toastOption);
    } catch (error) {
      toast.error(error.message, toastOption);
    } finally {
      setFetchLoading(false);
      actions.findOrganizationFeatures(organizationFeatureUIProps.queryParams);
      onHide();
    }

    console.log("features", features);
  }

  return (
    <Modal show={show} onHide={onHide} aria-labelledby="modal-sizes-title-lg">
      {actionsLoading && <ModalProgressBar variant="query" />}
      <Modal.Header closeButton>
        <Modal.Title id="modal-sizes-title-lg">
          Edit Fitur Lembaga{" "}
          {(organizationForEdit && organizationForEdit.name) ?? ""}
        </Modal.Title>
      </Modal.Header>
      <OrganizationFeatureEditForm
        saveOrganizationFeature={saveFeatures}
        loading={organizationLoading || fetchLoading}
        features={features}
        onHide={onHide}
      />
    </Modal>
  );
};
